import React from 'react';
import PropTypes from 'prop-types';

const InventoryClassMessage = ({ classOfService, name }) => (
  <span>
    {classOfService} ({name})
  </span>
);

InventoryClassMessage.propTypes = {
  classOfService: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};

export default InventoryClassMessage;
